import { render, staticRenderFns } from "./ActiveStatus.vue?vue&type=template&id=2c70aef8&scoped=true"
import script from "./ActiveStatus.vue?vue&type=script&lang=ts"
export * from "./ActiveStatus.vue?vue&type=script&lang=ts"
import style0 from "./ActiveStatus.vue?vue&type=style&index=0&id=2c70aef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c70aef8",
  null
  
)

export default component.exports